import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CoreScrollBusService {
  private readonly _scroll$ = new Subject<Event>();

  get scroll$(): Observable<Event> {
    return this._scroll$.asObservable();
  }

  emit(event: Event): void {
    this._scroll$.next(event);
  }
}
